export default function() {



































	return new Promise((resolve, reject) => {
		reject({
			message: '请在App中使用'
		})
	})

}
